import { AboutContainer, AboutContent, AboutSubtitle, AboutTitle } from "./styled";

const About = () => {
    return <AboutContainer>
        <AboutTitle>
            <span>About</span>
            <span style={{color: "#F7931E"}}>Us</span>
        </AboutTitle>
        <AboutSubtitle>
            Telma Micro Needles Pvt Ltd manufactures atraumatic surgical Needles, Sutures & Polypropylene Mesh.
        </AboutSubtitle>
        <AboutContent>
            This Company was incorporated in the year 2011 and it is promoted by Latha Subramanian. Latha was heading the needle division of M/S Sutures India Pvt Ltd from 2000 to 2013. Under her leadership the company initiated manufacturing needles from AISI 302.
        </AboutContent>
        <AboutContent>
            Further the company diversified into manufacturing synthetic absorbable sutures and Polypropylene meshes.
        </AboutContent>
    </AboutContainer>
}

export default About;